
/**
 * input_code_error
 * Ошибки при вводе кода из смс
 */
export interface InputCodeError {}

export function mapInputCodeErrorEvent(event: InputCodeError): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'input_code_error',
    event_properties: {},
  };
}
